import { defineComponent as _defineComponent } from 'vue'
import AzImg from '~/components/Atoms/AzImg.vue';
import type { Image } from '~/types/models/contentful/Image';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockImagesTextImageRightTextLeft',
  props: {
    title: null,
    text: null,
    classes: null,
    pictos: null,
    leafListOption: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  text?: string;
  classes?: any;
  pictos: Image[];
  leafListOption?: boolean;
};



function getImage(image: Image) {
  return image?.fields?.file?.url || '';
}

function getSize(image: Image) {
  return `${image.fields?.file?.details?.image?.width}x${image.fields?.file?.details?.image?.height}`;
}

return { __sfc: true,props, getImage, getSize, AzImg }
}

})